// import { useState } from "react";
import { useDispatch } from "react-redux";
import deleteImage from "../../assets/images/delete.svg";
import editImage from "../../assets/images/edit.svg";
import { editActive, removeItem } from "../../features/items/itemsSlice";
import numberWithCommas from "../../utils/numberComma";

export default function Transaction({ item }) {
  // const [enableEdit, setEnableEdit] = useState(false);
  const dispatch = useDispatch();
  const handleEdit = () => {
    dispatch(editActive(item));
  };
  const handleDelte = () => {
    dispatch(removeItem(item.id));
  };
  const { name, amount, type } = item;
  return (
    <li className={`transaction ${type === "income" ? "income" : "expense"} `}>
      <p>{name}</p>
      <div className="right">
        <p>৳ {numberWithCommas(amount)}</p>
        <button className="link" onClick={handleEdit}>
          <img alt="Edit" className="icon" src={editImage} />
        </button>
        <button className="link" onClick={handleDelte}>
          <img alt="Delete" className="icon" src={deleteImage} />
        </button>
      </div>
    </li>
  );
}
